// extracted by mini-css-extract-plugin
module.exports = {"laneCellDropTarget":"LaneCellDropTarget_laneCellDropTarget__320Lz","notEnoughSpaceWarning":"LaneCellDropTarget_notEnoughSpaceWarning__UqX47"};